import React, { Component, Fragment } from 'react';
import AddTrip from 'Components/AWLMultiMode/AddTrip';
import ResponsiveTable from 'Components/ResponsiveTable';
import { ReactComponent as EditIcon } from 'Icons/edit.svg';

class AWLMultiMode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: false,
            tripData: ''
        }
    }

    onEditTrip = (trip) => {
        const data = this.getEditTrip(trip);
        this.props.editTrip(trip);
        this.setState({
            isEdit: true,
            tripData: data
        })
    }

    getEditTrip = (trip) => {
        if(['Yard To Yard (Container)', "Port To Port"].includes(trip.legName) && trip.legBudget) {
            return [{
                legName: trip.legName,
                legType: trip.legType,
                from: trip.ftlStops[0],
                to: trip.ftlStops[1],
                docs: trip.docs,
                transporters: trip.transporters,
                tatValue: trip.multiModeTATValue,
                tatUnit: trip.multiModeTATUnit,
                businessVolumeValue: trip.multiModeBusinessVolumeValue,
                businessVolumeUnit: trip.multiModeBusinessVolumeUnit,
                legBudget: trip.legBudget,
                qbr: trip.qbr,
                lpp: trip.lpp.toString(),
                childs: []
            }]
        } else if(trip.legName === 'Yard To Yard (BCN)') {
            return [{
                legName: trip.legName,
                legType: trip.legType,
                from: trip.ftlStops[0],
                to: trip.ftlStops[1],
                distance: trip.distance,
                commodityCategory: trip.commodityCategory,
                commodityName: trip.commodityName,
                wagonType: trip.wagonType,
                freightValue: trip.freightValue,
                loadType: trip.loadType,
                tarrifLines: trip.tarrifLines,
                childs: []
            }]
        } 
        else {
            return [{
                legName: trip.legName,
                legType: trip.legType,
                childs:[{
                    transporters: trip.transporters,
                    remarks: trip.multiModeRemarks,
                    pricing_basis_name: trip.pricingBasisName,
                    pricing_basis: trip.pricingBasis,
                    docs: trip.docs,
                    providerName: trip.providerName,
                    providerType: trip.providerType,
                    childCharges: [this.getChildCharges(trip)]
                }]
            }]
        }
    }

    getChildCharges = (trip) => {
        let transData = {};
        if(trip.providerType === 2) {
            transData = {
                number_of_vehicle: trip.numberOfVehicle,
                to: trip.ftlStops[1],
                distance: trip.distance,
                route_code: trip.routeCode
            }
        }
        const data = {
            from: trip.ftlStops[0],
            qbr: trip.qbr,
            lpp: trip.lpp.toString(),
            marketRate: trip.marketRate,
            contractTenureFrom: trip.contractTenureFrom,
            contractTenureTo: trip.contractTenureTo,
            multi_mode_movement_type: trip.multi_mode_movement_type,
            multi_mode_movement_type_id: trip.multi_mode_movement_type_id,
            vehicle_details: {
                vehicle_type: trip.vehicleType,
                vehicle_type_name: trip.vehicleTypeName
            },
            ...transData
        }
        if(data.multi_mode_movement_type_id === 4) {
            data.vehicle_details['vehicle_body_type'] = trip.vehicleBodyType;
            data.vehicle_details['vehicle_body_type_name'] = trip.vehicleBodyTypeName;
        } else if([1,2,3].includes(data.multi_mode_movement_type_id)) {
            data['container_details'] =  trip.container_details;
        }

        return data;
    }

    onCancelEdit = () => {
        this.setState({ isEdit: false, tripData: '' })
    }
    
    render() {
        const { 
            addingTrip, 
            pricingBasis,
            businessVolumes,
            rfq,
            hideAddTrip,
            vehicleTypes,
            vehicleBodyTypes,
            addTrip,
            transporters,
            trips,
            offset,
            searchGroupsAndTransporters,
            YardToYardConstants,
            containerTypes,
            multiModalMovementTypes,
            depotLocationList,
            plantLocationList,
            viewMode
        } = this.props;

        return (
            <Fragment>
                {(addingTrip && !viewMode) ? 
                    <AddTrip
                        businessVolumes={businessVolumes}
                        rfq={rfq}
                        hideAddTrip={hideAddTrip}
                        vehicleTypes={vehicleTypes}
                        vehicleBodyTypes={vehicleBodyTypes}
                        addTrip={addTrip}
                        transporters={transporters}
                        searchGroupsAndTransporters={searchGroupsAndTransporters}
                        YardToYardConstants={YardToYardConstants}
                        tripData={this.state.tripData}
                        isEdit={this.state.isEdit}
                        onCancelEdit={this.onCancelEdit}
                        pricingBasis={pricingBasis}
                        containerTypes={containerTypes}
                        multiModalMovementTypes={multiModalMovementTypes}
                        depotLocationList={depotLocationList}
                        plantLocationList={plantLocationList}
                    /> :
                    <Fragment>
                        <ResponsiveTable>
                            {(trips || []).map((trip, index) => {
                            return (
                                <Fragment key={(index + 1)}>
                                    {index === 0 && <div className="flex flex-middle mb-20 ">
                                        <div className="fBold fs-16 header-dark-color wt-50 pl-15">Trip</div>
                                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Leg Type</div>
                                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Provider</div>
                                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">From</div>
                                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">To</div>
                                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Movement Type</div>
                                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Vehicle Details / No. Of Man Power Per Shift</div>
                                        <div className="fBold fs-16 header-dark-color wt-100 pl-15">TAT</div>
                                        <div className="fBold fs-16 header-dark-color wt-100 pl-15">Route Code</div>
                                        <div className="fBold fs-16 header-dark-color wt-100 pl-15">LPP</div>
                                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Ceiling Price</div>
                                        <div className="fBold fs-16 header-dark-color wt-150 pl-15">Remarks</div>
                                        {!viewMode && <div className="fBold fs-16 header-dark-color pl-15">Actions</div>}

                                    </div>}
                                    <div className="flex flex-middle border-top-light pt-25 pb-25 bg-hover-theme pr">
                                        <div className="fs-14 table-text-color wt-50 pl-5">{index + offset + 1}</div>
                                        <div className="fs-14 table-text-color wt-150 pl-15">{trip.legName}</div>
                                        <div className="fs-14 table-text-color wt-150 pl-15">
                                            {trip.providerName}
                                            <span>{['Plant To Yard', 'Plant To Port'].includes(trip.legName) ? ` At ${trip.from}` : (['Yard To Depot', 'Port To Depot'].includes(trip.legName) ? ` At ${trip.from}` : '')}</span>
                                        </div>
                                        <div className="fs-14 table-text-color wt-150 pl-15">{trip.from || ''}</div>
                                        <div className="fs-14 table-text-color wt-150 pl-15">{trip.to || 'N/A'}</div>
                                        <div className="fs-14 table-text-color wt-150 pl-15">{trip.multi_mode_movement_type}</div>
                                        <div className="fs-14 table-text-color wt-150 pl-15">{trip.providerName === 'Transporter' ? trip.vehicleTypeName : trip.noOfManPower}
                                            <div>{trip.providerName === 'Transporter' && (trip.vehicleBodyTypeName || (trip.container_details || {})['container_type']) || ''}</div>
                                        </div>
                                        <div className="fs-14 table-text-color wt-100 pl-15">{(trip.biddingDetails.tatUnit && trip.biddingDetails.tatValue) ? (`${trip.biddingDetails.tatValue} ${trip.biddingDetails.tatUnitName}`) : 'N/A'}</div>        
                                        <div className="fs-14 table-text-color wt-100 pl-15">{trip.routeCode}</div>                            
                                        <div className="fs-12 fBold table-text-color wt-100 pl-15">{trip.lpp}</div>
                                        <div className="fs-12 fBold table-text-color wt-150 pl-15">
                                            {trip.qbr}
                                            <div>{trip.pricingBasisName}</div>
                                        </div>
                                        <div className="fs-12 fBold table-text-color wt-150 pl-15">{trip.multiModeRemarks}</div>
                                        {!viewMode && <div className="fs-12 fBold table-text-color wt-150 pl-15">
                                            <EditIcon className="wt-15 ht-15 ml-5 curP fBold" onClick={() => this.onEditTrip(trip)} />
                                        </div>}
                                    </div>
                                </Fragment>
                            )})}
                        </ResponsiveTable>
                    {!(trips && trips.length > 0) && <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No Trip Has Been Added</div>}
                    </Fragment>
                }
            </Fragment>
        )
    }
}

export default AWLMultiMode;